import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { User } from "pwapi";

import { FeatureFlags } from "shared/reducers/sysReducer";

import ClinicFilter from "components/admin/filters/ClinicFilter";
import TextInput from "components/customInputs/TextInput";

type CaseFiltersProps = {
  accession: string;
  orderingDoctorName: string;
  patientClinicName: string;
  patientName: string;
  patientDateOfBirth: string;
  status: string;
  lab: string;
  activeAssignmentName: string;

  onChange: Function;
  features?: FeatureFlags;
  user?: User;
};

const CaseFilters = (props: CaseFiltersProps) => {
  const fullname =
    props.user &&
    `${props.user.first_name || ""} ${props.user.last_name || ""}`.trim();
  return (
    <>
      <TextInput
        id="accession"
        name="accession"
        value={props.accession}
        label="Accession"
        onChange={(e: any) => props.onChange("accession", e.target.value)}
        onClear={() => props.onChange("accession", "")}
      />
      <TextInput
        id="orderingDoctorName"
        name="orderingDoctorName"
        value={props.orderingDoctorName}
        label="Ordering Provider"
        onChange={(e: any) =>
          props.onChange("orderingDoctorName", e.target.value)
        }
        onClear={() => props.onChange("orderingDoctorName", "")}
        button={
          props.user?.user_type === "physician" && (
            <button
              type="button"
              data-testid="orderingDoctorButton"
              onClick={() => props.onChange("orderingDoctorName", fullname)}
            >
              <FontAwesomeIcon icon="user" />
            </button>
          )
        }
      />
      <TextInput
        id="activeAssignmentName"
        name="activeAssignmentName"
        value={props.activeAssignmentName}
        label="Active Assignment"
        onChange={(e: any) =>
          props.onChange("activeAssignmentName", e.target.value)
        }
        onClear={() => props.onChange("activeAssignmentName", "")}
        button={
          props.user?.user_type === "dermpath" && (
            <button
              type="button"
              data-testid="activeAssignmentButton"
              onClick={() => {
                props.onChange("activeAssignmentName", fullname);
              }}
            >
              <FontAwesomeIcon icon="user" />
            </button>
          )
        }
      />
      {props.user?.user_type === "dermpath" ? (
        <TextInput
          id="patientClinicName"
          name="patientClinicName"
          value={props.patientClinicName}
          label="Clinic"
          onChange={(e: any) =>
            props.onChange("patientClinicName", e.target.value)
          }
          onClear={() => props.onChange("patientClinicName", "")}
        />
      ) : (
        <ClinicFilter
          onChange={(newValue: any) => {
            props.onChange("patientClinicName", newValue.value);
          }}
          value={props.patientClinicName}
        />
      )}
      <TextInput
        id="patientName"
        name="patientName"
        value={props.patientName}
        label="Patient"
        onChange={(e: any) => props.onChange("patientName", e.target.value)}
        onClear={() => props.onChange("patientName", "")}
      />
      {props.features?.statusFilter && (
        <TextInput
          id="status"
          name="status"
          value={props.status}
          label="Status"
          onChange={(e: any) => props.onChange("status", e.target.value)}
        />
      )}
    </>
  );
};

export default CaseFilters;
